export * from './full-layout.component';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/containers/full-layout/index.ts